module.exports = __webpack_public_path__ + "img/SK35799200.f694b7ee.png";